import {
  USER_LOGIN,
  USER_LOGIN_SUCCEEDED,
  USER_LOGIN_FAILED,
  USER_REGISTER,
  USER_REGISTER_SUCCEEDED,
  USER_REGISTER_FAILED,
  USER_VERIFICATION,
  USER_VERIFICATION_SUCCEEDED,
  USER_VERIFICATION_FAILED,
  USER_VERIFICATION_REQUEST,
  USER_VERIFICATION_REQUEST_SUCCEEDED,
  USER_VERIFICATION_REQUEST_FAILED,
  USER_LOGOUT,
  USER_LOGOUT_SUCCEEDED,
  GET_PROFILE,
  GET_PROFILE_SUCCEEDED,
  GET_PROFILE_FAILED,
  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCEEDED,
  UPDATE_PROFILE_FAILED,
  SET_DATA,
  ADD_DATA,
  CHANGE_USER_PASSWORD,
  CHANGE_USER_PASSWORD_SUCCEEDED,
  CHANGE_USER_PASSWORD_FAILED,
  ADD_JOB_EXPERIENCE,
  ADD_JOB_EXPERIENCE_SUCCEEDED,
  ADD_JOB_EXPERIENCE_FAILED,
  EDIT_JOB_EXPERIENCE,
  EDIT_JOB_EXPERIENCE_SUCCEEDED,
  EDIT_JOB_EXPERIENCE_FAILED,
  DELETE_JOB_EXPERIENCE,
  DELETE_JOB_EXPERIENCE_SUCCEEDED,
  DELETE_JOB_EXPERIENCE_FAILED,
  ADD_EDUCATION_SUCCEEDED,
  ADD_EDUCATION,
  ADD_EDUCATION_FAILED,
  EDIT_EDUCATION,
  EDIT_EDUCATION_SUCCEEDED, EDIT_EDUCATION_FAILED,
  DELETE_EDUCATION,
  DELETE_EDUCATION_SUCCEEDED,
  DELETE_EDUCATION_FAILED,
  REQUEST_TOKEN,
  REQUEST_TOKEN_SUCCEEDED,
  REQUEST_TOKEN_FAILED,
  TOKEN_VALIDATION,
  TOKEN_VALIDATION_SUCCEEDED,
  TOKEN_VALIDATION_FAILED,
  RESET_PASSWORD,
  RESET_PASSWORD_SUCCEEDED,
  RESET_PASSWORD_FAILED,
  CLEAR_AUTH_DATA,
  SET_AUTH_NESTED_DATA
} from './index';

export const userLogin = (data = {}) => {
  return {
    type: USER_LOGIN,
    payload: {
      data,
      url: 'login/',
      onSuccess: USER_LOGIN_SUCCEEDED,
      onFailure: USER_LOGIN_FAILED,
    },
  };
};

export const userRegister = (data = {}) => {
  return {
    type: USER_REGISTER,
    payload: {
      data,
      url: 'signup/',
      onSuccess: USER_REGISTER_SUCCEEDED,
      onFailure: USER_REGISTER_FAILED,
    },
  };
};

export const getProfile = () => {
  return {
    type: GET_PROFILE,
    payload: {
      url: 'my-profile/',
      onSuccess: GET_PROFILE_SUCCEEDED,
      onFailure: GET_PROFILE_FAILED,
    },
  };
};


export const updateProfile = (data = {}) => {
  return {
    type: UPDATE_PROFILE,
    payload: {
      data,
      url: 'my-profile/',
      onSuccess: UPDATE_PROFILE_SUCCEEDED,
      onFailure: UPDATE_PROFILE_FAILED,
    },
  };
};

export const logoutUser = () => {
  return {
    type: USER_LOGOUT,
    payload: {
      onSuccess: USER_LOGOUT_SUCCEEDED,
    },
  };
};


export const userVerification = (data = {}) => {
  return {
    type: USER_VERIFICATION,
    payload: {
      data,
      url: 'validate-token/',
      onSuccess: USER_VERIFICATION_SUCCEEDED,
      onFailure: USER_VERIFICATION_FAILED,
    },
  };
};


export const userVerificationRequest = (data = {}) => {
  return {
    type: USER_VERIFICATION_REQUEST,
    payload: {
      data,
      url: 'request-token/',
      onSuccess: USER_VERIFICATION_REQUEST_SUCCEEDED,
      onFailure: USER_VERIFICATION_REQUEST_FAILED,
    },
  };
};

export const changePassword = (data = {}) => {
  return {
    type: CHANGE_USER_PASSWORD,
    payload: {
      data,
      url: 'change-password/',
      onSuccess: CHANGE_USER_PASSWORD_SUCCEEDED,
      onFailure: CHANGE_USER_PASSWORD_FAILED
    }
  }
}

// Forgot password
export const requestToken = (data = {}, is_password = "True") => {
  return {
    type: REQUEST_TOKEN,
    payload: {
      data,
      url: `request-token/?is_password=${is_password}`,
      onSuccess: REQUEST_TOKEN_SUCCEEDED,
      onFailure: REQUEST_TOKEN_FAILED
    }
  }
};

export const tokenValidation = (data = {}, is_password = "True") => {
  return {
    type: TOKEN_VALIDATION,
    payload: {
      data,
      url: `validate-token/?is_password=${is_password}`,
      onSuccess: TOKEN_VALIDATION_SUCCEEDED,
      onFailure: TOKEN_VALIDATION_FAILED
    }
  }
};

export const resetPassword = (data = {}) => {
  return {
    type: RESET_PASSWORD,
    payload: {
      data,
      url: `rest-password-confirm/`,
      onSuccess: RESET_PASSWORD_SUCCEEDED,
      onFailure: RESET_PASSWORD_FAILED
    },
  };
};



export const setData = (data = {}) => {
  return {
    type: SET_DATA,
    payload: {
      data,
    },
  };
};

export const setAuthNested = (data = {}) => {
  return {
    type: SET_AUTH_NESTED_DATA,
    payload: {
      data,
    },
  };
};

export const addData = (data = {}) => {
  return {
    type: ADD_DATA,
    payload: {
      data,
    },
  };
};

// Tutor Job

export const addJobExperience = (data = {}) => {
  return {
    type: ADD_JOB_EXPERIENCE,
    payload: {
      data,
      url: 'tutor/job-experience/',
      onSuccess: ADD_JOB_EXPERIENCE_SUCCEEDED,
      onFailure: ADD_JOB_EXPERIENCE_FAILED,
    },
  };
}

export const editJobExperience = (data = {}, id = {}) => {
  return {
    type: EDIT_JOB_EXPERIENCE,
    payload: {
      data,
      url: `tutor/job-experience/${id}/`,
      onSuccess: EDIT_JOB_EXPERIENCE_SUCCEEDED,
      onFailure: EDIT_JOB_EXPERIENCE_FAILED,
    },
  };
}

export const deleteJobExperience = (id = {}) => {
  return {
    type: DELETE_JOB_EXPERIENCE,
    payload: {
      url: `tutor/job-experience/${id}/`,
      onSuccess: DELETE_JOB_EXPERIENCE_SUCCEEDED,
      onFailure: DELETE_JOB_EXPERIENCE_FAILED,
    },
  };
}

// Tutor Education

export const addEducation = (data = {}) => {
  return {
    type: ADD_EDUCATION,
    payload: {
      data,
      url: 'tutor/education/',
      onSuccess: ADD_EDUCATION_SUCCEEDED,
      onFailure: ADD_EDUCATION_FAILED,
    },
  };
}

export const editEducation = (data = {}, id = {}) => {
  return {
    type: EDIT_EDUCATION,
    payload: {
      data,
      url: `tutor/education/${id}/`,
      onSuccess: EDIT_EDUCATION_SUCCEEDED,
      onFailure: EDIT_EDUCATION_FAILED,
    },
  };
}

export const deleteEducation = (id = {}) => {
  return {
    type: DELETE_EDUCATION,
    payload: {
      url: `tutor/education/${id}/`,
      onSuccess: DELETE_EDUCATION_SUCCEEDED,
      onFailure: DELETE_EDUCATION_FAILED,
    },
  };
}

export const clearauthData = () => {
  return {
    type: CLEAR_AUTH_DATA
  }
}
